import React, { useState, useRef, useEffect } from "react";
import "./translator.css";

export default function TranslatorPopup() {
    const [show, setShow] = useState(false);
    const cardRef = useRef(null);
    const btnRef = useRef(null);

    // Load Google Translate script safely
    useEffect(() => {
        if (window.googleTranslateScriptAdded) return;
        window.googleTranslateScriptAdded = true;

        const script = document.createElement("script");
        script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateInit";
        script.async = true;
        document.body.appendChild(script);

        window.googleTranslateInit = () => {
            if (!window.google || !window.google.translate) return;

            new window.google.translate.TranslateElement(
                {
                    pageLanguage: "en",
                    autoDisplay: false,
                },
                "google_translate_element_hidden"
            );
        };
    }, []);

    // Fix “Script error.”
    window.addEventListener("error", function (e) {
        if (e.message === "Script error.") {
            e.preventDefault();
            return false;
        }
    });

    const applyLanguage = (lang) => {
        const select = document.querySelector(".goog-te-combo");

        if (!select) {
            alert("Translator still loading… please wait 1 second.");
            return;
        }

        select.value = lang;
        select.dispatchEvent(new Event("change"));

        // Wait for Google translation to finish applying DOM spans
        setTimeout(() => {

            if (lang !== "en") {
                document.body.classList.add("font-normalized");
            } else {
                document.body.classList.remove("font-normalized");
            }

        }, 300);
    };

    const languages = [
        { code: "en", label: "English" },
        { code: "hi", label: "हिंदी" },
        { code: "te", label: "తెలుగు" },
        { code: "ta", label: "தமிழ்" },
        { code: "ml", label: "മലയാളം" },
        { code: "kn", label: "ಕನ್ನಡ" },
        { code: "mr", label: "मराठी" },
        { code: "gu", label: "ગુજરાતી" },
        { code: "bn", label: "বাংলা" },
        { code: "pa", label: "ਪੰਜਾਬੀ" },
        { code: "ur", label: "اردو" },
        { code: "as", label: "অসমীয়া" },
        { code: "or", label: "ଓଡ଼ିଆ" },
        { code: "ne", label: "नेपाली" }
    ];

    // Close popup when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (
                show &&
                cardRef.current &&
                !cardRef.current.contains(e.target) &&
                btnRef.current &&
                !btnRef.current.contains(e.target)
            ) {
                setShow(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [show]);

    return (
        <>
            {/* Toggle Button */}
            <button
                className="translator-btn notranslate"
                translate="no"
                onClick={() => setShow(!show)}
                title="Change language"
                ref={btnRef}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.97778 2.04696C2.99018 2.17462 2.18144 3.00424 2.0489 4.02555C1.9837 4.52798 1.9837 14.4355 2.0489 14.9379C2.14965 15.7141 2.64629 16.3977 3.35246 16.7322C3.69213 16.8931 3.71199 16.8961 4.54607 16.9128L5.39427 16.9297L5.40935 18.245L5.42443 19.5603L5.61121 19.747C5.87039 20.0061 6.17656 20.0308 6.82955 19.8456C8.2722 19.4364 9.51141 18.4821 10.2006 17.2498L10.3853 16.9195L11.7134 16.9331L13.0416 16.9466L13.067 21.6185L13.0924 26.2903L13.256 26.6357C13.5905 27.3419 14.2741 27.8386 15.0503 27.9393C15.55 28.0042 25.4582 28.0045 25.9655 27.9397C27.0076 27.8065 27.8087 27.0042 27.9445 25.9575C28.0097 25.455 28.0097 15.5475 27.9445 15.0451C27.8437 14.2689 27.3471 13.5853 26.6409 13.2508C26.3013 13.09 26.2814 13.0869 25.4473 13.0702L24.5991 13.0533L24.5841 11.7335L24.569 10.4137L24.3551 10.2144C24.1607 10.0331 24.1162 10.0149 23.8657 10.0149C23.3002 10.0149 22.225 10.4195 21.4876 10.9097C20.8161 11.3561 20.1805 12.0399 19.7928 12.7333L19.6081 13.0635L18.28 13.0499L16.9518 13.0364L16.9264 8.36455L16.901 3.69268L16.7443 3.3626C16.3982 2.63364 15.73 2.14355 14.9459 2.0433C14.4764 1.98333 4.44441 1.98668 3.97778 2.04696ZM20.6537 2.18803C20.3427 2.41685 18.9666 3.8402 18.9084 3.99325C18.8122 4.24635 18.8454 4.50091 19.0024 4.71338C19.083 4.82231 19.5 5.257 19.9292 5.67929C20.7867 6.52302 20.9275 6.6096 21.2857 6.51317C21.5287 6.44771 21.7832 6.17725 21.8284 5.93635C21.8687 5.72139 21.7505 5.42615 21.5349 5.20342L21.3752 5.03838H21.5319C21.6181 5.03838 21.8708 5.07291 22.0934 5.11516C24.5269 5.57682 26.2825 7.565 26.4663 10.0676C26.5117 10.6858 26.5892 10.8613 26.8926 11.0318C27.2307 11.2218 27.6358 11.1069 27.8466 10.7612C27.9708 10.5576 27.9787 10.0447 27.8684 9.35479C27.3847 6.32995 24.9487 3.97076 21.9356 3.6093C21.6523 3.57527 21.4115 3.54064 21.4004 3.53226C21.3893 3.52388 21.4736 3.41577 21.5877 3.29201C21.8224 3.0374 21.8913 2.79725 21.8049 2.53548C21.6493 2.06412 21.0628 1.88705 20.6537 2.18803ZM3.84026 3.6292C3.49663 3.87331 3.52014 3.44177 3.52014 9.50424V14.9954L3.7195 15.2093L3.91887 15.4231L5.10329 15.4485C6.4133 15.4766 6.50003 15.4962 6.72804 15.8159C6.84225 15.976 6.84687 16.0216 6.86246 17.137C6.87129 17.7724 6.88922 18.2923 6.90222 18.2923C6.91522 18.2923 7.04507 18.232 7.19076 18.1583C8.05272 17.7224 8.74913 16.9937 9.13263 16.1266C9.2672 15.8223 9.41025 15.636 9.5885 15.5327C9.66035 15.4911 10.4733 15.4665 12.368 15.4485L15.0459 15.4231L15.2371 15.2319L15.4283 15.0406V9.47727V3.91388L15.2145 3.71441L15.0006 3.51494H9.5009H4.00114L3.84026 3.6292ZM22.7341 11.8609C21.8772 12.3229 21.2582 12.9846 20.8493 13.8759C20.6715 14.2635 20.5118 14.4247 20.2448 14.4867C20.1373 14.5117 19.3498 14.5326 18.4946 14.5333L16.9397 14.5345L16.9161 14.9031C16.8504 15.9263 15.9311 16.8453 14.9075 16.9109L14.5381 16.9347L14.5516 21.5019L14.5651 26.0691L14.7789 26.2686L14.9928 26.4681H20.484C26.5583 26.4681 26.1219 26.4922 26.3613 26.1427L26.4733 25.9794V20.4834V14.9876L26.2739 14.7737L26.0745 14.5599L24.8901 14.5345C23.5902 14.5066 23.4943 14.4848 23.254 14.1627C23.1538 14.0285 23.1461 13.9459 23.1309 12.8551C23.1221 12.2147 23.0993 11.6912 23.0802 11.6919C23.0611 11.6925 22.9054 11.7686 22.7341 11.8609ZM20.1204 16.8323C19.971 16.9312 19.7315 17.3778 18.3356 20.1594C17.0797 22.6619 16.7233 23.4141 16.7235 23.5618C16.724 24.1179 17.3864 24.4763 17.8456 24.1691C17.975 24.0825 18.1008 23.892 18.3483 23.4079L18.6783 22.7622L20.5188 22.7616L22.3593 22.761L22.6872 23.4155C22.9456 23.9311 23.052 24.0928 23.1887 24.1772C23.5264 24.386 23.9733 24.2695 24.1884 23.9168C24.3996 23.5703 24.4071 23.5891 22.6747 20.1458C20.9078 16.6341 20.961 16.7181 20.5065 16.7181C20.3701 16.7181 20.2307 16.7593 20.1204 16.8323ZM2.41595 18.9344C2.13462 19.0731 2.04748 19.2783 2.04748 19.8024C2.04748 20.6972 2.30626 21.7274 2.75644 22.6251C3.43691 23.9819 4.57893 25.0946 5.97191 25.7581C6.61916 26.0665 7.23143 26.247 8.00534 26.3576L8.60573 26.4433L8.47009 26.57C8.39549 26.6396 8.2885 26.7862 8.23233 26.8958C7.92181 27.5015 8.53956 28.1427 9.17118 27.8702C9.26106 27.8315 9.72688 27.403 10.2064 26.9181C11.4619 25.6484 11.4632 25.7137 10.1543 24.4028C9.36618 23.6135 9.20479 23.4749 9.03772 23.4441C8.49335 23.3437 8.04911 23.8002 8.16733 24.3385C8.18709 24.4285 8.29769 24.6046 8.41316 24.7298L8.62304 24.9575L8.29327 24.92C7.03313 24.7767 5.81113 24.1645 4.95202 23.2461C4.54582 22.8119 4.26769 22.3964 4.00236 21.8278C3.7191 21.2206 3.57351 20.6503 3.51968 19.9367C3.48611 19.4912 3.45128 19.316 3.37023 19.1849C3.18011 18.8773 2.7571 18.7662 2.41595 18.9344ZM19.9602 20.1966L19.415 21.2884H20.5066C21.107 21.2884 21.5983 21.2768 21.5983 21.2625C21.5983 21.2287 20.5354 19.1048 20.5184 19.1048C20.5112 19.1048 20.26 19.5961 19.9602 20.1966Z" fill="currentColor" stroke="none"></path>
                    <path d="M13.5112 6.0579C13.5664 6.0579 13.6112 6.10267 13.6112 6.1579V6.8168C13.6112 6.87202 13.5664 6.9168 13.5112 6.9168H12.3659C12.3106 6.9168 12.2659 6.96157 12.2659 7.0168V12.9364C12.2659 12.9917 12.2211 13.0364 12.1659 13.0364H11.2127C11.1575 13.0364 11.1127 12.9917 11.1127 12.9364V10.4309C11.1127 10.3757 11.0679 10.3309 11.0127 10.3309H9.67152C9.60895 10.3309 9.55988 10.3881 9.56201 10.4507C9.56278 10.4731 9.56316 10.4976 9.56316 10.5242C9.56316 11.0681 9.35095 11.5083 8.92652 11.8447C8.5021 12.1811 7.9015 12.3493 7.12472 12.3493C6.60568 12.3493 6.12301 12.2713 5.67673 12.1152C5.63722 12.1014 5.61121 12.0639 5.61121 12.022V11.2816C5.61121 11.2087 5.68693 11.1601 5.75426 11.1883C6.20234 11.3754 6.64715 11.4689 7.08869 11.4689C7.45705 11.4689 7.77337 11.3866 8.03763 11.222C8.3019 11.0502 8.43403 10.7782 8.43403 10.4061C8.43403 9.79768 7.96957 9.49348 7.04064 9.49348H6.69619C6.64096 9.49348 6.59619 9.44871 6.59619 9.39348V8.69164C6.59619 8.63641 6.64096 8.59164 6.69619 8.59164H6.98058C7.37297 8.59164 7.66927 8.51649 7.86947 8.36618C8.07767 8.21588 8.18178 8.00831 8.18178 7.74348C8.18178 7.20667 7.83343 6.93827 7.13673 6.93827C6.75613 6.93827 6.40842 7.00241 6.0936 7.13068C6.02516 7.15856 5.94754 7.10983 5.94754 7.03593V6.31111C5.94754 6.26874 5.9742 6.23083 6.01443 6.21753C6.37966 6.0968 6.76978 6.03643 7.18478 6.03643C7.87347 6.03643 8.406 6.17958 8.78238 6.46588C9.15876 6.75217 9.34694 7.13868 9.34694 7.62539C9.34694 7.99042 9.24284 8.29461 9.03463 8.53796C8.94266 8.64546 8.83662 8.7376 8.71651 8.81437C8.6222 8.87466 8.63935 9.13058 8.74112 9.17719C8.88357 9.24243 9.01159 9.32773 9.12519 9.43309C9.14438 9.45089 9.16941 9.46128 9.19559 9.46128H11.0127C11.0679 9.46128 11.1127 9.4165 11.1127 9.36128V7.0168C11.1127 6.96157 11.0679 6.9168 11.0127 6.9168H10.1677C10.1124 6.9168 10.0677 6.87202 10.0677 6.8168V6.1579C10.0677 6.10267 10.1124 6.0579 10.1677 6.0579H13.5112Z" fill="currentColor" stroke="none"></path>
                </svg>
            </button>

            {/* Hidden Google Translate Element */}
            <div id="google_translate_element_hidden" style={{ display: "none" }} />

            {/* Language Popup */}
            {show && (
                <div className="translator-popup notranslate" translate="no" ref={cardRef}>
                    <div className="popup-header notranslate">
                        <h5>Choose Language</h5>
                        <button className="close-btn" onClick={() => setShow(false)}>✕</button>
                    </div>

                    <div className="language-grid notranslate" translate="no">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                className="lang-card"
                                onClick={() => applyLanguage(lang.code)}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}